require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/core-js/modules/es7.symbol.observable.js
// module id = 681
// module chunks = 81